import Box from "./Box/Box";
import styles from "./Infos.module.css";
import { RiRobot2Fill } from "react-icons/ri";
import { IoCart } from "react-icons/io5";
import { FaStore } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react"

function Infos() {
  const [userCount, setUserCount] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    fetch("https://eclipsebots.com/api/users/total")
      .then(res => res.json())
      .then(data => setUserCount(data.total));
  }, []);


  return (
    <div className={styles.boxes}>
      <Box icon={<RiRobot2Fill />} name={"2"} detail={"Bots ativos"} />
      <Box icon={<IoCart />} name={"2"} detail={"Vendas Realizadas"} />
      <Box icon={<FaStore />} name={"2"} detail={"Lojas"} />
      <Box icon={<FaUsers />} name={userCount} detail={"Usuários"} />
    </div>
  )
}

export default Infos;